import Slider from '@carvana/showroom-forms/Slider';
import type { ownProps as SliderProps } from '@carvana/showroom-forms/Slider/Slider';
import cx from 'classnames';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import SearchSource from '~/constants/srp/SearchSource';
import SearchEventsDataContext from '~/context/srp/SearchEventsDataContext';
import styles from './RangeSlider.module.scss';

function useSlideSizeCalculationTrigger(show: boolean) {
  const [trigger, setTrigger] = useState(0);

  useEffect(() => {
    if (show) setTrigger(Date.now());
  }, [show]);

  return trigger;
}

type OwnProps = SliderProps & {
  inputWidth?: string;
  isShowing: boolean;
  labelTextTransform?: string;
};

export default function RangeSlider({
  className,
  dualRange,
  inputWidth,
  isShowing,
  labelTextTransform,
  onUpdate,
  ...props
}: OwnProps) {
  const { setSearchSource } = useContext(SearchEventsDataContext);
  const sizeCalculationTrigger = useSlideSizeCalculationTrigger(isShowing);
  const localValues = useRef<number[]>();

  const onUpdateHandler = useCallback(
    (v: number[] | undefined) => {
      // Slider component updates on click and mouse up, so we need to check if the values have changed
      if (
        v?.[0] === localValues.current?.[0] &&
        v?.[1] === localValues.current?.[1]
      )
        return;

      setSearchSource(SearchSource.Facet);
      if (onUpdate) onUpdate(v);

      localValues.current = v;
    },
    [localValues, onUpdate, setSearchSource]
  );

  return (
    <div
      style={{
        ['--input-width']: inputWidth,
        ['--label-text-transform']: labelTextTransform
      }}
    >
      <Slider
        className={cx(
          styles.rangeSlider,
          className,
          dualRange ? 'dual-range' : 'single-range'
        )}
        dualRange={dualRange}
        sizeCalculationTrigger={sizeCalculationTrigger}
        onUpdate={onUpdateHandler}
        {...props}
      />
    </div>
  );
}
